/**
 * @typedef {import('../types.js').CreateTracker} CreateTracker
 * @typedef {import('../types.js').TrackCurrent} TrackCurrent
 * @typedef {import('../types.js').TrackMove} TrackMove
 * @typedef {import('../types.js').TrackShift} TrackShift
 */

/**
 * Track positional info in the output.
 *
 * @type {CreateTracker}
 */
export function track(config) {
  // Defaults are used to prevent crashes when older utilities somehow activate
  // this code.

  /* c8 ignore next 5 */
  var options = config || {};
  var now = options.now || {};
  var lineShift = options.lineShift || 0;
  var line = now.line || 1;
  var column = now.column || 1;
  return {
    move: move,
    current: current,
    shift: shift
  };
  /**
   * Get the current tracked info.
   *
   * @type {TrackCurrent}
   */

  function current() {
    return {
      now: {
        line: line,
        column: column
      },
      lineShift: lineShift
    };
  }
  /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @type {TrackShift}
   */


  function shift(value) {
    lineShift += value;
  }
  /**
   * Move past some generated markdown.
   *
   * @type {TrackMove}
   */


  function move(input) {
    // eslint-disable-next-line unicorn/prefer-default-parameters
    var value = input || '';
    var chunks = value.split(/\r?\n|\r/g);
    var tail = chunks[chunks.length - 1];
    line += chunks.length - 1;
    column = chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift;
    return value;
  }
}